const AgroforestryProjectFactory = {
  "_format": "hh-sol-artifact-1",
  "contractName": "AgroforestryProjectFactory",
  "sourceName": "contracts/core/AgroforestryProjectFactory.sol",
  "abi": [
    {
      "inputs": [],
      "name": "AUTH_MAIN_OWNER",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "AUTH_OWNER",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "CANNOT_REMOVE_MAIN",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "CLOSE_AFTER_CLAIM",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "FARMER_BLOCKED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "FINALIZE_BEFORE_CLAIM",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "HIGH_COMMISSION",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "INDEX_OUT_OF_BOUNDS",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "INVALID",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "INVALID_SPECIES",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "INVALID_STAGES",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "INVALID_YEARS",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NOT_PROJECT",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NO_LOGIC",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NO_PROJECTS",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NO_PROJECT_LOGIC",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NO_STABLECOIN",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NO_TOKEN_LOGIC",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "POOL_EXISTS",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "POOL_INIT_FAILED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "PROJECT_INIT_FAILED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "SPECIES_LEN",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "STAGE_LEN",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "TOKEN_INIT_FAILED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "WRONG_STABLE",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ZERO_ADDRESS",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ZERO_AUDITOR",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ZERO_FARMER",
      "type": "error"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "address",
          "name": "previousAdmin",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "address",
          "name": "newAdmin",
          "type": "address"
        }
      ],
      "name": "AdminChanged",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "beacon",
          "type": "address"
        }
      ],
      "name": "BeaconUpgraded",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "farmer",
          "type": "address"
        }
      ],
      "name": "FarmerBlocked",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "farmer",
          "type": "address"
        }
      ],
      "name": "FarmerUnblocked",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint8",
          "name": "version",
          "type": "uint8"
        }
      ],
      "name": "Initialized",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "string",
          "name": "contractType",
          "type": "string"
        },
        {
          "indexed": false,
          "internalType": "address",
          "name": "newLogic",
          "type": "address"
        }
      ],
      "name": "LogicUpdated",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "owner",
          "type": "address"
        }
      ],
      "name": "OwnerAdded",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "owner",
          "type": "address"
        }
      ],
      "name": "OwnerRemoved",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "Paused",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "project",
          "type": "address"
        }
      ],
      "name": "ProjectApproved",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "project",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "token",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "uint32",
          "name": "projectId",
          "type": "uint32"
        },
        {
          "indexed": false,
          "internalType": "string",
          "name": "projectType",
          "type": "string"
        },
        {
          "indexed": false,
          "internalType": "address",
          "name": "creator",
          "type": "address"
        }
      ],
      "name": "ProjectCreated",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "project",
          "type": "address"
        }
      ],
      "name": "ProjectFailed",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "pool",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "uint8",
          "name": "speciesId",
          "type": "uint8"
        },
        {
          "indexed": true,
          "internalType": "uint64",
          "name": "claimTimestamp",
          "type": "uint64"
        }
      ],
      "name": "SpeciesFuturesPoolCreated",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "Unpaused",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "implementation",
          "type": "address"
        }
      ],
      "name": "Upgraded",
      "type": "event"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "owner",
          "type": "address"
        }
      ],
      "name": "addOwner",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "agroforestryProjectLogic",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "agroforestryTokenLogic",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "projectAddr",
          "type": "address"
        }
      ],
      "name": "approveProject",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "farmer",
          "type": "address"
        }
      ],
      "name": "blockFarmer",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "name": "blockedFarmers",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "stableCoin",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "farmer",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "auditor",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "usdcTreasury",
          "type": "address"
        },
        {
          "internalType": "uint8",
          "name": "maxProjectYear",
          "type": "uint8"
        },
        {
          "internalType": "uint8",
          "name": "speciesCount",
          "type": "uint8"
        },
        {
          "internalType": "uint8[]",
          "name": "yearStageCounts",
          "type": "uint8[]"
        },
        {
          "internalType": "string",
          "name": "tokenUri",
          "type": "string"
        },
        {
          "internalType": "uint64[]",
          "name": "stageCosts",
          "type": "uint64[]"
        },
        {
          "internalType": "uint64[]",
          "name": "stagePrices",
          "type": "uint64[]"
        },
        {
          "internalType": "uint128[][]",
          "name": "predictedRevenues",
          "type": "uint128[][]"
        },
        {
          "internalType": "uint64[][]",
          "name": "claimTimestamps",
          "type": "uint64[][]"
        }
      ],
      "name": "createAgroforestryProject",
      "outputs": [
        {
          "internalType": "address",
          "name": "projectAddr",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "tokenAddr",
          "type": "address"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "speciesId",
          "type": "uint8"
        },
        {
          "internalType": "uint64",
          "name": "claimTimestamp",
          "type": "uint64"
        },
        {
          "internalType": "address",
          "name": "stableCoin",
          "type": "address"
        },
        {
          "internalType": "uint64",
          "name": "depositCloseTime",
          "type": "uint64"
        },
        {
          "internalType": "uint64",
          "name": "finalizeEarliestTime",
          "type": "uint64"
        },
        {
          "internalType": "string",
          "name": "name",
          "type": "string"
        },
        {
          "internalType": "string",
          "name": "symbol",
          "type": "string"
        }
      ],
      "name": "createSpeciesFuturesPool",
      "outputs": [
        {
          "internalType": "address",
          "name": "pool",
          "type": "address"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "defaultFarmerFee",
      "outputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "defaultInvestorFee",
      "outputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "defaultStableCoin",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "fundingAddress",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getLastProject",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint32",
          "name": "index",
          "type": "uint32"
        }
      ],
      "name": "getProject",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint32",
          "name": "index",
          "type": "uint32"
        }
      ],
      "name": "getProjectWithToken",
      "outputs": [
        {
          "internalType": "address",
          "name": "project",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "token",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "speciesId",
          "type": "uint8"
        },
        {
          "internalType": "uint64",
          "name": "claimTimestamp",
          "type": "uint64"
        }
      ],
      "name": "getSpeciesFuturesPool",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "inOwners",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "agroforestryProjectLogic_",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "agroforestryTokenLogic_",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "speciesFuturesPoolLogic_",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "defaultStableCoin_",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "kycLogic_",
          "type": "address"
        }
      ],
      "name": "initialize",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "isFundingAddress",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "name": "isInvestmentToken",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "isMainOwner",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "name": "isProject",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "name": "isProjectContract",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "kycWhitelist",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "mainOwner",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "projectAddr",
          "type": "address"
        }
      ],
      "name": "markProjectFailed",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "pause",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "projectAddr",
          "type": "address"
        }
      ],
      "name": "pauseProject",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "paused",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "projectCount",
      "outputs": [
        {
          "internalType": "uint32",
          "name": "",
          "type": "uint32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "name": "projectIdOf",
      "outputs": [
        {
          "internalType": "uint32",
          "name": "",
          "type": "uint32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "name": "projectToken",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "name": "projects",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "proxiableUUID",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "owner",
          "type": "address"
        }
      ],
      "name": "removeOwner",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "stableCoin",
          "type": "address"
        }
      ],
      "name": "setDefaultStableCoin",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "rate",
          "type": "uint8"
        }
      ],
      "name": "setFarmerFee",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "setFundingAddress",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "rate",
          "type": "uint8"
        }
      ],
      "name": "setInvestorFee",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "_kycWhitelist",
          "type": "address"
        }
      ],
      "name": "setKYCWhitelist",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "agroforestryProjectLogic_",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "agroforestryTokenLogic_",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "speciesFuturesPoolLogic_",
          "type": "address"
        }
      ],
      "name": "setLogics",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "setTreasuryContractAddress",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "setTreasuryTokenReceiver",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "setUsdcTreasuryAddress",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        },
        {
          "internalType": "uint64",
          "name": "",
          "type": "uint64"
        }
      ],
      "name": "speciesFuturesPool",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "speciesFuturesPoolLogic",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "treasuryContractAddress",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "treasuryTokenReceiver",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "target",
          "type": "address"
        }
      ],
      "name": "trustProjectSystemContract",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "farmer",
          "type": "address"
        }
      ],
      "name": "unblockFarmer",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "unpause",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "projectAddr",
          "type": "address"
        }
      ],
      "name": "unpauseProject",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "newImplementation",
          "type": "address"
        }
      ],
      "name": "upgradeTo",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "newImplementation",
          "type": "address"
        },
        {
          "internalType": "bytes",
          "name": "data",
          "type": "bytes"
        }
      ],
      "name": "upgradeToAndCall",
      "outputs": [],
      "stateMutability": "payable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "usdcTreasuryAddress",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    }
  ],
  "bytecode": "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",
  "deployedBytecode": "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",
  "linkReferences": {},
  "deployedLinkReferences": {}
};

export default AgroforestryProjectFactory;
